import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter((segment) => segment);

  // パスと日本語ラベルのマッピング
  const pathLabels: { [key: string]: string } = {
    admin: '管理画面',
    dashboard: 'ダッシュボード',
    stores: '店舗管理',
    users: 'ユーザー管理',
    customers: '顧客管理',
    settings: 'システム設定',
    'audit-logs': '監査ログ',
    reports: 'レポート'
  };

  // パンくずリストの生成
  const breadcrumbs: BreadcrumbItem[] = [];
  let currentPath = '';

  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    if (pathLabels[segment]) {
      breadcrumbs.push({
        label: pathLabels[segment],
        path: currentPath
      });
    }
  });

  // パンくずリストが空の場合は表示しない
  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;

          if (isLast) {
            return (
              <Typography key={crumb.path} color="text.primary">
                {crumb.label}
              </Typography>
            );
          }

          return (
            <Link
              key={crumb.path}
              component={RouterLink}
              to={crumb.path}
              color="inherit"
              underline="hover"
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {crumb.label}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs;
